<div class="row" *ngIf="selectedItemDetails?.length > 0 && !product.isEpin()">
  <div class="col-12">
    <h3 class="m-t-xl">{{ pdpStaticContent?.specifications }}</h3>
    <div class="specification-table m-t-xl">
      <div
        class="row specification-row multi"
        *ngFor="let spec of selectedItemDetails; let i = index"
      >
        <div class="col-3 specification-col">
          <p class="small content">{{ spec.group }}</p>
        </div>
        <div class="col-9 specification-col">
          <span
            *ngIf="
              spec.group !== productSpecificationConst.FREQUENCIES &&
              spec.group !== productSpecificationConst.NETWORK_CAPABILITY
            "
          >
            <p
              class="xsmall"
              *ngFor="
                let specificationValue of spec.specificationValues;
                let j = index;
                let isLast = last
              "
            >
              <!--Only show specification if their values are not booleans, if booleans and if true don't show value
              if boolean and false -->
              <span *ngIf="specificationValue.value !== 'false'"
                >{{ specificationValue.name }}
                <span *ngIf="specificationValue.value !== 'true'"
                  >: {{ specificationValue.value }}
                </span>
              </span>
            </p>
          </span>
          <span *ngIf="spec.group == productSpecificationConst.FREQUENCIES">
            <p class="xsmall">
              <span
                *ngFor="
                  let specificationValue of spec.specificationValues;
                  let j = index;
                  let isLast = last
                "
              >
                <!--Only show specification if their values are not booleans, if booleans and if true don't show value
              if boolean and false -->
                <span *ngIf="specificationValue.value !== 'false'"
                  >{{ specificationValue.name }}:
                  <span *ngIf="specificationValue.value !== 'true'">
                    {{ specificationValue.value }}{{ isLast ? '' : '; ' }}
                  </span>
                </span>
              </span>
            </p>
          </span>
          <span *ngIf="spec.group == productSpecificationConst.NETWORK_CAPABILITY">
            <p class="xsmall">
              <span
                *ngFor="
                  let specificationValue of spec.specificationValues;
                  let j = index;
                  let isLast = last
                "
              >
                <!--Only show specification if their values are not booleans, if booleans and if true don't show value
              if boolean and false -->
                <span *ngIf="specificationValue.value !== 'false'"
                  >{{ specificationValue.name }}{{ isLast ? '' : ', ' }}
                  <span *ngIf="specificationValue.value !== 'true'"
                    >: {{ specificationValue.value }}
                  </span>
                </span>
              </span>
            </p>
          </span>
        </div>
      </div>
      <div class="row specification-row multi" *ngIf="selectedDevice.uSkuIndicator">
        <div class="col-3 specification-col">
          <p class="small content">{{ pdpStaticContent?.simIncluded }}</p>
        </div>
        <div class="col-9 specification-col">
          <p class="xsmall">
            <span>{{ pdpStaticContent?.no }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selectedItemDetails?.length > 0">
    <!-- US561804 - added legal text for WEA for devices -->
    <p class="small col-xs-12 m-t-lg p-l-xl" *ngIf="isWEACapable()">
      <span class="bold vertical-bottom">{{ pdpStaticContent?.weaCapable }}  </span>
      <span class="vertical-bottom">{{ pdpStaticContent?.see }} </span>
      <a href="{{ pdpStaticContent?.weaUrl }}" class="vertical-bottom" target="_blank">{{
        pdpStaticContent?.weaLink
      }}</a>
    </p>
    <p class="small col-xs-12 m-t-lg p-l-xl">
      <img src="{{ pdpStaticContent?.P65WarningImageUrl }}" class="alert-img p-r-xs" alt="Alert" />
      <span class="bold vertical-bottom">{{ pdpStaticContent?.Warning }}: </span>
      <span class="vertical-bottom">{{ pdpStaticContent?.P65WarningMessage }} – </span>
      <a href="{{ pdpStaticContent?.p65WarningUrl }}" class="vertical-bottom" target="_blank">{{
        pdpStaticContent?.P65WarningLink
      }}</a>
    </p>
  </div>
  <div class="row m-t-xl">
    <div class="col-12">
      <hr class="divider" />
    </div>
  </div>
</div>
